
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const SUPABASE_ANON = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export function getSupabaseEnvStatus(): { hasUrl: boolean; hasAnon: boolean } {
  return {
    hasUrl: !!SUPABASE_URL,
    hasAnon: !!SUPABASE_ANON
  };
}

export function makeSupabaseClient() {
  if (!SUPABASE_URL || !SUPABASE_ANON) {
    const message = 'Missing Supabase env. Configure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY';
    console.error(message, { hasUrl: !!SUPABASE_URL, hasAnon: !!SUPABASE_ANON });
    throw new Error(message);
  }
  return createClient<Database>(SUPABASE_URL, SUPABASE_ANON, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce'
    }
  });
}

let memoizedClient: any | null = null;

export function getSupabase() {
  if (!memoizedClient) {
    memoizedClient = makeSupabaseClient();
  }
  return memoizedClient;
}

// Backward-compatible lazy proxy: existing imports like `import { supabase } from ...` will
// still work without creating the client at module import time. The actual client is created
// upon first property access. This prevents white screens from import-time throws.
export const supabase = new Proxy({} as any, {
  get(_target, prop, receiver) {
    const client = getSupabase();
    return Reflect.get(client, prop, receiver);
  },
  set(_target, prop, value, receiver) {
    const client = getSupabase();
    return Reflect.set(client, prop, value, receiver);
  }
});

// Note: For production hardening, consider migrating to @supabase/ssr with HttpOnly cookies
// to avoid localStorage-based session persistence.
